module.exports = __webpack_public_path__ + "img/icon-more.ae55961b.svg";